module.exports = __webpack_public_path__ + "static/media/dashboard_icon.59c3d962.svg";